<div class="tnb">
    <tnb-westnetz-page>
        <div class="page-area">
            <tnb-navigation-header></tnb-navigation-header>
            <router-outlet class="main-area"></router-outlet>
        </div>
        <tnb-westnetz-footer></tnb-westnetz-footer>
    </tnb-westnetz-page>
</div>
